export default __webpack_public_path__ + "static/media/sliedes.67b1b707.jpg";